import React, { useEffect, useRef } from 'react';

function AutoExpandTextarea({
  value,
  onChange,
  placeholder,
  required,
  id,
  minRows = 4,
  className = ''
}) {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = 'auto';

      // Calculate minimum height based on minRows
      const computedStyle = window.getComputedStyle(textarea);
      let lineHeight = parseInt(computedStyle.lineHeight);

      // If lineHeight is NaN or invalid, calculate it from font-size
      if (isNaN(lineHeight)) {
        const fontSize = parseInt(computedStyle.fontSize) || 14;
        lineHeight = Math.floor(fontSize * 1.6); // Use 1.6 line-height ratio
      }

      const padding = parseInt(computedStyle.paddingTop) + parseInt(computedStyle.paddingBottom);
      const minHeight = (lineHeight * minRows) + padding;

      // Set height to either scrollHeight or minHeight, whichever is larger
      const newHeight = Math.max(textarea.scrollHeight, minHeight);
      textarea.style.height = newHeight + 'px';
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  useEffect(() => {
    // Initial height adjustment when component mounts
    adjustHeight();
  }, []);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
    adjustHeight();
  };

  return (
    <textarea
      ref={textareaRef}
      id={id}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      className={`auto-expand-textarea ${className}`}
      style={{
        overflow: 'hidden',
        resize: 'none'
      }}
    />
  );
}

export default AutoExpandTextarea;
